import { Dispatch } from "redux";
import {
  ERROR_LOADING_MARKER_GROUPS,
  GET_ALL_MARKER_GROUPS,
  RESET_DATA,
  START_LOADING_MARKER_GROUPS,
  STOP_LOADING_MARKER_GROUPS,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchMarkerGroupsAction =
  () => async (dispatch: Dispatch, getState: any) => {
    dispatch({ type: START_LOADING_MARKER_GROUPS });
    try {
      const currentState = getState();
      const queryString = generateQueryStringForUsers(
        currentState.Filters.markerGroupsFilter
      );

      const { data } =
        await apiLibrary.markerGroupsAndStyles.getAllMarkerGroups(queryString);
      dispatch({
        type: GET_ALL_MARKER_GROUPS,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      dispatch({ type: ERROR_LOADING_MARKER_GROUPS });
      // dispatch(fetchError(error))
    } finally {
      dispatch({ type: STOP_LOADING_MARKER_GROUPS });
      // dispatch(loadingState(false))
    }
  };
